import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Crescent } from "./Decor";
import { DonateButton } from "./DonateButton";

const links = [
  { label: "Home", to: "/" },
  { label: "Sponsors", to: "/sponsors" },
  { label: "Get Involved", to: "/#get-involved" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-cream/95 backdrop-blur border-b-2 border-forest" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <Crescent size={36} />
          <div className="leading-none">
            <span className="numeral text-2xl text-forest tracking-wide">PAK FEST 2026</span>
            <div className="eyebrow text-rust text-[0.55rem] mt-0.5">Winnipeg · CPTCA</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) =>
            l.to.startsWith("/#") ? (
              <a
                key={l.to}
                href={l.to}
                className="eyebrow text-forest hover:text-rust transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            ) : (
              <Link
                key={l.to}
                to={l.to}
                className="eyebrow text-forest hover:text-rust transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </Link>
            )
          )}
          <a href="/#join-sponsor" className="btn-rust px-4 py-2 text-xs" data-testid="nav-cta-sponsor">
            Become a Sponsor
          </a>
          <a href="/#join-vendor" className="btn-rust px-4 py-2 text-xs" data-testid="nav-cta-vendor">
            Become a Vendor
          </a>
          <DonateButton className="btn-forest px-4 py-2 text-xs" label="Donate" testid="nav-donate" />
        </div>

        <button className="md:hidden text-forest" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-forest/30 bg-cream px-4 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="eyebrow text-forest">
              {l.label}
            </Link>
          ))}
          <a href="/#join-sponsor" onClick={() => setOpen(false)} className="btn-rust px-5 py-2 text-xs text-center">
            Become a Sponsor
          </a>
          <a href="/#join-vendor" onClick={() => setOpen(false)} className="btn-rust px-5 py-2 text-xs text-center">
            Become a Vendor
          </a>
          <DonateButton className="btn-forest px-5 py-2 text-xs w-full" label="Donate" testid="nav-donate-mobile" />
        </div>
      )}
    </nav>
  );
};
